var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.00053 6.5C4.16353 6.5 4.31653 6.4205 4.41003 6.2865L7.91003 1.2865C8.01703 1.134 8.02903 0.9345 7.94403 0.769C7.85753 0.6035 7.68703 0.5 7.50053 0.5H0.499533C0.313033 0.5 0.142533 0.6035 0.0560328 0.769C-0.0289672 0.9345 -0.0169672 1.134 0.0900328 1.2865L3.59003 6.2865C3.68353 6.4205 3.83653 6.5 3.99953 6.5H4.00053Z",
    fill: "#3DA64F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGroup);
export default __webpack_public_path__ + "static/media/GreenGroup.6b86e8971a423fcb41e31b5b4aeaecf4.svg";
export { ForwardRef as ReactComponent };